import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CohortsTab } from "./cohorts-tab";
import { ObservabilityTab } from "./observability-tab";
import { SettingsTab } from "./settings-tab";
import { StepsTab } from "./steps-tab";
import { useFeatureFlagEnabled } from "@posthog/react";
import { Navigate } from "@tanstack/react-router";
import { Route } from "@/routes/_authenticated/sms-lifecycle";

export const SmsLifecyclePage = () => {
  const { tab: activeTab, cohortId: selectedCohortId } = Route.useSearch();
  const navigate = Route.useNavigate();
  const isSmsLifecycleEnabled = useFeatureFlagEnabled("enable-sms-lifecycle");

  if (isSmsLifecycleEnabled === undefined) {
    return null;
  }

  if (isSmsLifecycleEnabled === false) {
    return <Navigate to="/" />;
  }

  return (
    <div className="container mx-auto max-w-7xl p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">SMS Lifecycle Editor V2</h1>
        <p className="text-muted-foreground">
          Manage cohorts, message steps, and settings
        </p>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={(val) => {
          navigate({
            search: {
              tab: val as "cohorts" | "settings" | "observability",
              cohortId: val === "cohorts" ? undefined : selectedCohortId,
            },
            replace: true,
          });
        }}
      >
        <TabsList className="mb-4">
          <TabsTrigger value="cohorts">Cohorts</TabsTrigger>
          <TabsTrigger value="settings">Settings</TabsTrigger>
          <TabsTrigger value="observability">Observability</TabsTrigger>
        </TabsList>

        <TabsContent value="cohorts">
          {selectedCohortId ? (
            <StepsTab
              cohortId={selectedCohortId}
              onBack={() =>
                navigate({
                  search: { tab: "cohorts", cohortId: undefined },
                  replace: true,
                })
              }
            />
          ) : (
            <CohortsTab
              onSelectCohort={(id) =>
                navigate({
                  search: { tab: "cohorts", cohortId: id },
                  replace: true,
                })
              }
            />
          )}
        </TabsContent>

        <TabsContent value="settings">
          <SettingsTab />
        </TabsContent>

        <TabsContent value="observability">
          <ObservabilityTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};
